import{
  FETCH_REVIEW_DATA, REVIEW_DATA_REQUEST
} from '../constants/review'

import {review} from '../utils/review/'

export function getOne(id) {
  return (dispatch) => {
    dispatch({
      type   : REVIEW_DATA_REQUEST,
      payload: {
        page: {
          data    : null,
          fetching: true,
        }
      }
    })

    review.getOne(id).then(data => {
      dispatch({
        type   : FETCH_REVIEW_DATA,
        payload: {
          page: {
            data    : data.review,
            fetching: false
          }
        }
      })
    });
  }
}
export function getFilterReviewList(limit = null) {
  return (dispatch) => {
    dispatch({
      type   : REVIEW_DATA_REQUEST,
      payload: {
        data    : null,
        fetching: true
      }
    })

    review.getFilterReviewList(limit).then(data => {
      dispatch({
        type   : FETCH_REVIEW_DATA,
        payload: {
          data    : data,
          fetching: false
        }
      })
    });
  }
}
export function AddReview(formData) {
  return (dispatch) => {
    dispatch({
      type   : REVIEW_DATA_REQUEST,
      payload: {
        avis:{
          data    : null,
          fetching: true,
          check:false,
        }
      }
    })
    review.AddReviews(formData).then(d => {
       let check = null
      if (d.id_reviews!==0) {
        check = 1
      }
        dispatch({
          type   : FETCH_REVIEW_DATA,
          payload: {
            avis:{
              data    : d,
              fetching: false,
              check:check,
            }
          }
        })
     
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/reviewActions.js